<script>
function handlerTooltips(item) {
  const { currentIndex, tooltip } = item
  return tooltip[currentIndex]
}

function getTooltips(item, h) {
  const { tooltip } = item
  if (tooltip) {
    return h('a-tooltip', {
      attrs: {
        overlayClassName: 'tooltipsClass',
        placement: 'bottomLeft'
      },
      scopedSlots: {
        title() {
          return h('span', handlerTooltips(item))
        }
      }
    }, [
      h('my-icon', {
        attrs: { type: 'icon-prompt-fill' },
        class: {
          'my-icon': true,
          'my-icon-question': true
        }
      })
    ])
  }
}

function getCustomSwitchIcon(item, h) {
  const { isSwitch, switchIcons, currentIndex } = item
  if (!isSwitch) return ''
  const child = switchIcons.reduce((pre, cur, index) => {
    pre.push(
      h('my-icon', {
        attrs: {
          type: cur,
          id: index
        },
        class: {
          'custom-icon-item': true,
          'custom-icon-active': currentIndex === index
        },
        on: {
          click: (e) => this.updateCurrentIndex(e, index, item)
        }
      })
    )
    return pre
  }, [])
  return h('span', { class: 'custom-switch-wrap' }, child)
}
export default {
  props: {
    item: Object
  },
  methods: {
    updateCurrentIndex(e, index, item) {
      e.stopPropagation()
      this.$emit('updateIndex', { index, item })
    }
  },

  render(h) {
    return (
      <span class="right-wrap">
        {getTooltips.call(this, this.item, h)}
        {getCustomSwitchIcon.call(this, this.item, h)}
      </span>
    )
  }
}
</script>
